import {node_observable_component} from 'common/util/ComponentDecorator';
@node_observable_component
export class jsTabs {
	static classname = 'js-tabs';

	constructor($decorator) {
		$decorator.on('click', '[data-js-tab]', function () {
			const btn = $(this);
			const targetEl = $decorator.find(`[data-js-tab-target="${btn.attr('data-js-tab')}"]`);
			$decorator.find('[data-js-tab]').removeClass('js-active');
			btn.addClass('js-active');
			$decorator.find('[data-js-tab-target]').removeClass('js-active');
			targetEl.addClass('js-active');
		})
	}
}
